/**
 * Estilos dentro del Shadow DOM de Shopify Forms (el CSS del tema no aplica ahí).
 * Se actualiza el textContent en cada scan para reflejar cambios en el archivo.
 */
(function () {
  var WRAP = '.ecoway-forms-faq__app';
  var STYLE_ID = 'ecoway-forms-faq-embed-styles';

  var CSS =
    'form{' +
    'margin-top:0!important;' +
    'padding-top:0!important;' +
    '}' +
    'h1,h2:first-of-type{' +
    'color:#505050!important;' +
    'font-family:Oswald,system-ui,sans-serif!important;' +
    'font-size:48px!important;' +
    'font-style:normal!important;' +
    'font-weight:700!important;' +
    'line-height:72px!important;' +
    'letter-spacing:0.96px!important;' +
    'text-transform:uppercase!important;' +
    'margin-top:0!important;' +
    '}' +
    '@media (max-width:749px){' +
    'h1,h2:first-of-type{' +
    'font-size:24px!important;' +
    'line-height:26px!important;' +
    'letter-spacing:0.6px!important;' +
    'text-align:center!important;' +
    'width:100%!important;' +
    '}' +
    'form h1+*,form h2:first-of-type+*,' +
    'form h1+* p,form h2:first-of-type+* p,' +
    'form h1+* span,form h2:first-of-type+* span{' +
    'text-align:center!important;' +
    '}' +
    '}';

  function inject(shadow) {
    if (!shadow) return;
    var el = shadow.getElementById(STYLE_ID);
    if (el) {
      el.textContent = CSS;
      return;
    }
    el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = CSS;
    shadow.appendChild(el);
  }

  function processHost(node) {
    if (!node || !node.shadowRoot) return;
    var sr = node.shadowRoot;
    if (sr.querySelector('form')) {
      inject(sr);
    }
    sr.querySelectorAll('*').forEach(processHost);
  }

  function scan() {
    document.querySelectorAll(WRAP).forEach(function (wrap) {
      wrap.querySelectorAll('*').forEach(processHost);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
